package com.flowyride.feature.account

import com.flowyride.core.domain.account.AccountException
import com.flowyride.feature.account.resources.Res
import com.flowyride.feature.account.resources.error_email_taken
import com.flowyride.feature.account.resources.error_invalid
import com.flowyride.feature.account.resources.error_invalid_credentials
import com.flowyride.feature.account.resources.error_pending
import com.flowyride.feature.account.resources.error_refused
import com.flowyride.feature.account.resources.error_too_many_attempts
import com.flowyride.feature.account.resources.error_unreachable
import com.flowyride.feature.account.resources.error_username_taken
import org.jetbrains.compose.resources.StringResource

internal fun AccountException.toMessage(): StringResource = when (this) {
    is AccountException.InvalidCredentials -> Res.string.error_invalid_credentials
    is AccountException.Pending -> Res.string.error_pending
    is AccountException.Refused -> Res.string.error_refused
    is AccountException.UsernameTaken -> Res.string.error_username_taken
    is AccountException.EmailTaken -> Res.string.error_email_taken
    is AccountException.TooManyAttempts -> Res.string.error_too_many_attempts
    is AccountException.Unreachable -> Res.string.error_unreachable
    is AccountException.Invalid -> Res.string.error_invalid
}
